import React from 'react';
import clsx from 'clsx';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import entityIcons from '@/constants/images';
import { entityFilters } from '../constants';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const listItems = (intl) => entityFilters.map((filter) => ({
  key: filter,
  icon: entityIcons[filter],
  text: intl.formatMessage({ id: `entity.filter.${filter}` }),
  value: filter,
}));

const AuditEntityFilter = ({
  category,
  className,
  code,
  error,
  fluid,
  readStatus,
}) => {
  const intl = useIntl();
  const { entity } = Selectors.useAuditEntityFilter({ category, code });
  const onChange = Events.useSwitchEntityFilter(category, { code });

  return (
    <Dropdown
      id="audit_entity_dropdown"
      options={listItems(intl)}
      {...error && { disabled: true }}
      value={entity}
      clearable
      fluid={fluid}
      selection
      loading={readStatus === states.PENDING}
      placeholder={intl.formatMessage({ id: 'table.filter.by.type.placeholder' })}
      onChange={(e, { value }) => { onChange({ entity: value }); }}
      className={clsx('aridhia-audit-entity-filter', className)}
    />
  );
};

export default AuditEntityFilter;
